import { Component, OnInit, Inject, LOCALE_ID, Input } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MedicalInfoService } from '../medical-info.service';
import { medicineAllergyValidator } from '../validator/medicine-allergy-validator';
import { riskSportValidator } from '../validator/risk-sport-validator';
import { substanceAllergyValidator } from '../validator/substance-allergy-validator';
import * as moment from 'moment';
import { LocaleService } from '../locale.service';
import { TargetLanguage } from '../target-language';
import { BloodType } from '../blood-type';
import { LANGUAGES } from '../target-languages-list';
import { BLOODTYPES } from '../blood-type-list';
import { Booking } from '../booking';
import { skinTestResultValidator } from '../validator/skin-test-result-validator';
import { mentalDisorderValidator } from '../validator/mental-disorder-validator';
import { medicineDoseValidator } from '../validator/medicines-dose-validator';

@Component({
  selector: 'app-medical-info',
  templateUrl: './medical-info.component.html',
  styleUrls: ['./medical-info.component.css']
})
export class MedicalInfoComponent implements OnInit {

  locale: any;
  years: number[] = [];

  targetLanguages: TargetLanguage[] = LANGUAGES;
  bloodTypes: BloodType[] = BLOODTYPES;

  @Input()
  booking!: Booking;

  @Input()
  submitFail!: boolean;

  constructor(
    @Inject(LOCALE_ID)
    public localeId: string,
    private builder: FormBuilder,
    public medicalInfoService: MedicalInfoService,
    private localeService: LocaleService,
  ) { }

  ngOnInit() {
    this.locale = this.localeService.setCalendarLanguage(this.localeId);
    this.makeYears();
    this.medicalInfoService.medicalForm = this.builder.group({
      streetName: ["", Validators.required],
      streetNumber: [null, Validators.required],
      city: ["", Validators.required],
      postCode: ["", Validators.required],
      birthDate: [null, Validators.required],
      targetLanguage: ["", Validators.required],
      doctorName: ["", Validators.required],
      doctorPhoneNumber: ["", Validators.required],
      experiencedDiseases: [""],
      hasDiabetes: [false, Validators.required],
      hasAsthma: [false, Validators.required],
      hasHeartTrouble: [false, Validators.required],
      hasEpilepsy: [false, Validators.required],
      hasRheumatism: [false, Validators.required],
      hasPhysicalDisability: [false, Validators.required],
      hasSkinAffection: [false, Validators.required],
      hasSleepDisorder: [false, Validators.required],
      otherDiseases: [""],
      lastSkinTestDate: [null],
      skinTestPositive: [null],
      hadTetanusVaccination: [null, Validators.required],
      tetanusBoosterYear: [null],
      hasAllergiesToMedicines: [false, Validators.required],
      allergiesCauseMedicine: [""],
      hasAllergiesToSubstances: [false, Validators.required],
      allergiesCauseSubstance: [""],
      isIncontinent: [null, Validators.required],
      isQuicklyTired: [null, Validators.required],
      isSensitiveToChilling: [null, Validators.required],
      canSportWithoutRisk: [null, Validators.required],
      needMedicalTreatment: [null, Validators.required],
      medicinesQuantity: [""],
      bloodType: [null, Validators.required],
      otherInformations: [""],
      emergencyContactAddress: ["", Validators.required],
      hasMentalDisorder: [false, Validators.required],
      mentalDisorderDescription: [""],
      riskDescriptionToSport: [""]
    },
    {
      validator: [
        mentalDisorderValidator, 
        medicineAllergyValidator, 
        substanceAllergyValidator, 
        riskSportValidator,
        medicineDoseValidator,
        skinTestResultValidator
      ]
    });
  }

  makeYears(){
    let thisYear = moment().utc(true).year();
    let newYear = thisYear;
    this.years.push(thisYear);
    for(let i = 0; i < 20; i ++){
      newYear -= 1;
      this.years.push(newYear);
    }
  }

}
